export default __webpack_public_path__ + "static/media/back.83d62221.png";